import callApi from "res-api-cli/build/callApi";

/**
 * `DELETE /sessions` — sign out.
 *
 * CD-8740: takes **no request body**. oso-api identifies the session from the
 * HttpOnly `access_refresh` cookie, clears the user's refresh tokens, and
 * responds with deletions for `access_token`, `access_refresh`, `referral` and
 * the `has_session` marker.
 *
 * @param {object} opts callApi options — e.g. `fetcher` in tests.
 */
export default (opts = {}) =>
  callApi({
    ...opts,
    method: "DELETE",
    url: "/sessions"
  });
